import ApiServiceV2 from 'services/apiService/apiServiceV2';

const endpoint = orderId =>
	`/orders/v1/${encodeURIComponent(orderId)}/inventory-completion-restrictions`;

export const getInventoryCompletionRestrictions = orderId =>
	ApiServiceV2.get({ url: endpoint(orderId) });

export const updateInventoryCompletionRestrictions = (orderId, payload) =>
	ApiServiceV2.patch({
		url: endpoint(orderId),
		data: payload,
	});
